import { LocationDetails, LocationStats, ReportLocationStats } from '@dev/ee-api/ee-api-models';
import { CustomTableRowsProps } from '@dev/ee-components';

export enum WorldMapsEnum {
    World = 'world',
    USA = 'us',
    Canada = 'ca',
}

export enum GeographyToggleBtnValues {
    Number = 'number',
    Percent = 'percent',
}
export interface GeographyToggleBtnOptInterface {
    label: string;
    value: GeographyToggleBtnValues;
}

export interface DetailedRow {
    name?: string;
    opens?: number | string;
    rate?: string;
    opened?: number | string;
    clicked?: number | string;
    unsubscribed?: number | string;
}

export enum RadioValues {
    Opened = 'opened',
    Clicked = 'clicked',
    Unsubscribed = 'unsubscribed',
}

export interface FiltersInterface {
    showCampaignsFilter: boolean;
    from: string;
    to: string;
    setFrom: (from) => void;
    setTo: (to) => void;
    queryCampaignName?: string;
    setQueryCampaignName?: (queryCampaignName) => void;
    selectedCampaignName: string;
    setSelectedCampaignName: (selectedCampaignName) => void;
    selectedChannelName?: string;
    setSelectedChannelName?: (selectedChannelName) => void;
    queryChannelName?: string;
    setQueryChannelName?: (queryChannelName) => void;
}

export type DataItem = LocationStats | LocationDetails | ReportLocationStats;

export interface TableWithCountryProps {
    perPage: number;
    page: number;
    setPerPage: (perPage) => void;
    setPage: (page) => void;
    countryStatisticsFormat: GeographyToggleBtnValues;
    data: DataItem[];
    totalCount: number;
    loading: boolean;
    showOpens: boolean;
    showClicks: boolean;
}

export interface MobileTableProps {
    rows: CustomTableRowsProps[];
    headers: string[];
    dataCount: number;
    text: string;
}
export interface MapTooltipRow {
    value: number;
    description: string;
}
